import { render, staticRenderFns } from "./BulkSendTab.vue?vue&type=template&id=d85ae4f2&"
import script from "./BulkSendTab.vue?vue&type=script&lang=js&"
export * from "./BulkSendTab.vue?vue&type=script&lang=js&"
import style0 from "./BulkSendTab.vue?vue&type=style&index=0&id=d85ae4f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports